import { render, staticRenderFns } from "./orderServicerEvaluate.vue?vue&type=template&id=1fedd3cd&"
import script from "./orderServicerEvaluate.vue?vue&type=script&lang=ts&"
export * from "./orderServicerEvaluate.vue?vue&type=script&lang=ts&"
import style0 from "./orderServicerEvaluate.vue?vue&type=style&index=0&id=1fedd3cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports